import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import StatusCard from "../../components/cards/StatusCard";
import SummaryCard from "../../components/cards/SummaryCard";
import PageTitle from "../../components/partials/PageTitle";
import OverviewTable from "../../components/tables/admin/OverviewTable";
import { useDispatch } from "react-redux/es/exports";
import { getAllStaffs } from "../../redux/slice/staff/staffSlice";
import { BeatLoader } from "react-spinners";
import { fetchAllOffices } from "../../redux/slice/office/officeSlice";
import { getAllClauses } from "../../redux/slice/clauses/clauseSlice";
import { getDashStats, getLoggedInUsers } from "../../redux/slice/dash/dashSlice";
import CorporateOverviewTable from "../../components/tables/admin/CorporateOverviewTable";
import { fetchAllUsers } from "../../redux/slice/user/userSlice";
import { getAllWorkflow } from "../../redux/slice/workflow/workflowSlice";
import {
  getIndividualCustomers,
  resetCustomerStatus,
} from "../../redux/slice/customer/customerSlice";
import { getAllForms } from "../../redux/slice/form/formSlice";
import PendingActions from "../../components/cards/PendingActions";
import { getPendingClaims } from "../../redux/slice/pendingActions/pendingActionsSlice";
import { getAllPolicies, getAppliedPolicies } from "../../redux/slice/policy/policySlice";
import { getGlAccounts } from "../../redux/slice/accounting/accountingSlice";
import { getAllLifeCover } from "../../redux/slice/lifecover/lifecoverSlice";
import { getAllCovers } from "../../redux/slice/cover/coverSlice";
import { getSavingsPolicies } from "../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import GenderChart from "../../components/cards/GenderChart";
import PolicyClaimsChart from "../../components/cards/PolicyClaimsChart";
import { LoaderTwo } from "../../components/loader/LoaderTwo";


const Dashboard = () => {
  const { user } = useSelector((state) => state.auth);
  const { user_role: user_role_array } = useSelector(
    (state) => state?.auth?.user
  );
  const { staff_list } = useSelector((state) => state.staff);
  const { stat, loggedInUsers, isLoading } = useSelector((state) => state.dash);
  const { pending_claims_count } = useSelector(
    (state) => state?.pendingActions
  );
  

  const [policyType, setPolicyType] = useState('general')

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      navigate("/", { state: { from: location }, replace: true });
    }
  }, [location, navigate, user]);

  useEffect(() => {
    dispatch(getDashStats({office_id: user?.user?.office_id, policy_type: policyType}));
  }, [dispatch, user?.user?.office_id, policyType]);

  useEffect(() => {
    dispatch(
      getPendingClaims({ user_role_array, office_id: user?.user?.office_id })
    );

    dispatch(getLoggedInUsers(user?.user?.office_id))
  }, [dispatch, user?.user?.office_id, user_role_array]);

  const breadcrumb = {
    from: {
      title: "Dashboard",
      link: "/admin/dashboard",
    },
    current: {
      title: "overview",
      link: null,
    },
  };

  // fetch sfaff list on page load and offices
  useEffect(() => {
    dispatch(getAllStaffs({ pageNumber: 1, search: "" }));
    dispatch(getSavingsPolicies({ pageNumber: 1, office_id: user?.office_id }));
    dispatch(
      fetchAllOffices({
        office_id: parseInt(user?.user?.office_id),
        pageNumber: 1,
      })
    );
    dispatch(getAllClauses(1));
    dispatch(fetchAllUsers(1));
    dispatch(
      getIndividualCustomers({
        pageNumber: 1,
        office_id: user?.user?.office_id,
      })
    );
    dispatch(
      getAppliedPolicies({ pageNumber: 1, office_id: user?.user?.office_id })
    );
    dispatch(getAllWorkflow());
    dispatch(getAllForms(1));
    dispatch(getAllLifeCover(1));
    dispatch(getGlAccounts());
    dispatch(resetCustomerStatus());
    dispatch(getAllCovers())
    dispatch(getAllPolicies({ pageNumber: 1, office_id: user?.office_id }))
  }, [dispatch, user?.office_id, user?.user?.office_id]);

  if (staff_list.length === 0) {
    return (
      <h2>
        <BeatLoader />
      </h2>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Overview' breadcrumb={breadcrumb} />
      {isLoading && <div className='mt-2'>
        <LoaderTwo />
      </div>}
      {/* end page title */}
      <div className="d-flex justify-content-end mt-2 mb-3">
        <div className="d-flex flex-row">
          <label style={{ color: "#ffffff", backgroundColor: "#2E3192", padding: "8px 12px", borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px" }}>Filter by Policies</label>
          <select 
            value={policyType}
            onChange={(e) => setPolicyType(e.target.value)}
            className="form-select bg-bg-white" 
            style={{ width: "160px", borderTopRightRadius: "4px", borderBottomRightRadius: "4px", border: "1px solid #2E3192", paddingLeft: "10px" }}
          >
            <option value="general">General Policy</option>
            <option value="savings">Savings Policy</option>
          </select>
        </div>
      </div>

      {/* Summary Cards */}
      <div className='row'>
        <div className='col-md-12 col-xl-12 col-lg-12'>
          <div className='row'>
            {/*<!-- single card--> */}
            <div className='col-sm-6 col-md-6 col-lg-6 col-xxl-3 '>
              <SummaryCard
                title='Total Customers'
                total={stat?.total_customer_count}
                icon={{ class: "mdi mdi-account-multiple", bg: "#727cf540" }}
                borderColor='primary'
              />
            </div>
            {/*<!-- end single card--> */}

            {/*<!-- single card--> */}
            <div className='col-sm-6 col-md-6 col-lg-6 col-xxl-3'>
              <SummaryCard
                title='Total Staff'
                total={stat?.total_staff_count}
                icon={{
                  class: "mdi mdi-account-multiple",
                  bg: "#d6fad6",
                  color: "#0acf97",
                }}
                borderColor='success'
              />
            </div>
            {/*<!-- end single card--> */}

            {/*<!-- single card--> */}
            <div className='col-sm-6 col-md-6 col-lg-6 col-xxl-3'>
              <SummaryCard
                title={`Available ${policyType === 'general' ? 'General' : 'Savings'} Policies`}
                total={stat?.total_policies_count}
                icon={{
                  class: "mdi mdi-briefcase",
                  bg: "#fce6ea",
                  color: "#fa5c7c",
                }}
                borderColor='danger'
              />
            </div>
            {/*<!-- end single card--> */}

            {/*<!-- single card--> */}
            <div className='col-sm-6 col-md-6 col-lg-6 col-xxl-3'>
              <SummaryCard
                title={`Active ${policyType === 'general' ? 'General' : 'Savings'} Policies`}
                total={stat?.total_active_policies_count}
                icon={{
                  class: "mdi mdi-briefcase",
                  bg: "#f4eacd",
                  color: "#f3bd20",
                }}
                borderColor='warning'
              />
            </div>
            {/*<!-- end single card--> */}
          </div>
        </div>
      </div>
      {/* <!-- End Summmary Cards --> */}
      <div className="row mb-2">
        <PolicyClaimsChart chartData={policyType === 'general' ? stat?.generalPolicyGraphData : stat?.savingsPolicyGraphData} />
      </div>

      {/* row */}
      <div className='row'>
        {/* <BarChart /> */}
        {/* <!-- end col--> */}

        {/* <PieChart /> */}
        {/* end col */}
        <GenderChart chartData={stat?.genderData} />
        <PendingActions count={pending_claims_count} />
        <StatusCard data={loggedInUsers?.getUser} />
        {/* end col */}
      </div>
      {/* end row */}

      {/* Recent Individual Customers Overview table */}
      <OverviewTable items={stat?.individual_customers} />
      {/* End overview table */}

      {/* Recent Corporate Customers Overview table */}
      <CorporateOverviewTable items={stat?.cop_customers} />
      {/* End overview table */}
    </>
  );
};

export default Dashboard;
